<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('processes')"
      :columns="columns"
      :column_search="true"
      resource_url="/ngine/composer/process/datatables"
      mode="grid"
    >
      <template #item="item">
        <div class="card">
          <div class="card-image">
            <!-- <div
              class="is-pulled-right has-text-danger"
              :data-tooltip="$t('delete')"
              @click="remove(item)"
            >
              <span class="icon"><i class="fa fa-trash"></i></span>
            </div> -->
            <!-- <div
              class="is-pulled-right has-text-warning"
              :data-tooltip="$t('edit')"
              @click="edit(item)"
            >
              <span class="icon"><i class="fa fa-edit"></i></span>
            </div> -->
            <!-- <div
              class="is-pulled-right has-text-info"
              :data-tooltip="$t('compose')"
              @click="
                $router.push({ path: '/ngine/composer/process/' + item.uuid })
              "
            >
              <span class="icon"><i class="fa fa-sitemap"></i></span>
            </div> -->
            <figure class="image is-64x64 m-auto" @click="">
              <img src="https://cdn-icons-png.freepik.com/512/762/762722.png" />
            </figure>
          </div>
          <div class="card-content px-0" @click="">
            <div class="media">
              <div class="media-content">
                <p class="title is-5 has-text-centered">
                  {{ item.name }}
                </p>
                <!-- <pre>{{ item }}</pre> -->
              </div>
            </div>
          </div>
          <footer class="card-footer">
            <a
              class="card-footer-item button"
              :data-tooltip="$t('compose')"
              @click="
                $router.push({ path: '/ngine/composer/process/' + item.uuid })
              "
            >
              <span class="icon"><i class="fa fa-sitemap"></i></span>
            </a>
            <a
              class="card-footer-item has-text-danger button"
              :data-tooltip="$t('delete')"
              @click="remove(item)"
            >
              <span class="icon"><i class="fa fa-trash"></i></span>
            </a>
            <a
              class="card-footer-item button"
              :data-tooltip="$t('deploy')"
              @click="deploy(item)"
            >
              <span class="icon"><i class="fa fa-rocket"></i></span>
            </a>
          </footer>
        </div>
      </template>
      <template v-slot:buttons>
        <button class="button is-secondary is-rounded" @click="create">
          <span class="icon"><i class="fa fa-plus"></i></span>
          <span>{{ $t("create") }}</span>
        </button>
      </template>
    </generic-table>
  </div>

  <process-modal ref="process_modal" @success="refresh" />
  <deploy-modal ref="deploy_modal" />
</template>

<script>
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  error_message,
  format_date,
  format_currency,
} from "@/utils";
import ProcessModal from "../process_modal/Index.vue";
import DeployModal from "../deploy_modal/Index.vue";

export default {
  name: "NgineComposerProcessDatatable",
  components: { GenericTable, ProcessModal, DeployModal },
  data() {
    let v = this;
    return {
      columns: [
        {
          title: v.$t("date"),
          searchable: false,
          width: "15%",
          data: (row) => {
            return format_date(row.date);
            //return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
          },
        },
      ],
    };
  },
  methods: {
    format_currency,
    create() {
      let v = this;
      v.$refs.process_modal.show_modal();
    },
    refresh() {
      let v = this;
      v.$refs.datatable.refresh();
    },
    edit(process) {
      this.$refs.process_modal.edit_modal(process.uuid);
    },
    remove(process) {
      let v = this;
      confirm_deletion_dialog(
        v.$t("are you sure to delete process?"),
        v,
        () => {
          del("/ngine/composer/process", { uuid: process.uuid })
            .then(() => {
              v.refresh();
            })
            .catch((error) => {
              error_message(error);
            });
        }
      );
    },
    deploy(process) {
      let v = this;
      v.$refs.deploy_modal.show_modal(process);
    },
  },
  mounted() {
    this.refresh();
  },
};
</script>

<style></style>
